'use strict';

require('jquery-pjax');
require('../plugins/holdon');

$.pjax.defaults.timeout = 6000;
$(document).pjax('a[data-pjax]', '#pjax-container', { scrollTo: true });

$(document).on('pjax:beforeSend', function () {
    HoldOn.open();
});

$(document).on('pjax:complete', function () {
    HoldOn.close();
});
